"use strict";

var _regeneratorRuntime = require("/opt/build/repo/app/node_modules/@babel/runtime/regenerator/index.js");

var _slicedToArray = require("/opt/build/repo/app/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useReactiveBaseProps = void 0;

var react_1 = __importDefault(require("react"));

var hooks_1 = require("../../hooks");

var package_json_1 = __importDefault(require("../../../package.json"));

var replaceDocCountWithParent = function replaceDocCountWithParent(response) {
  Object.entries(response).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];

    return key !== "doc_count";
  }).forEach(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];

    var _a;

    (_a = value.buckets) === null || _a === void 0 ? void 0 : _a.forEach(function (bucket) {
      if (bucket.parent_docs) {
        bucket.doc_count = bucket.parent_docs.doc_count;
        delete bucket.parent_docs;
      }
    });
  });
  return response;
};

var useReactiveBaseProps = function useReactiveBaseProps() {
  var _a;

  var _ref5 = (0, hooks_1.useReactifySearchContext)(),
      options = _ref5.options,
      config = _ref5.config;

  var reactiveBaseProps = react_1.default.useMemo(function () {
    var _a;

    return {
      app: options.index,
      url: config.endpoint,
      credentials: options.credentials,
      theme: options.theme,
      initialState: (_a = options.preload) === null || _a === void 0 ? void 0 : _a.state,
      transformRequest: function transformRequest(request) {
        if (request.url.endsWith("?")) {
          request.url = request.url.substring(0, request.url.length - 1);
        }

        return request;
      },
      transformResponse: function transformResponse(response) {
        return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _b, _c, _d, _e;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  // support filtering inside nested aggregations by moving the inner aggregation
                  // up one level such that reactivesearch understands it
                  //
                  // see useReactiveFilterListProps > defaultQuery to see how a filter is being applied
                  // to variant aggregations to ensure that only in stock sizes are displayed as filter
                  // options, this involves a nested filter, which requires this fix
                  //
                  // https://github.com/appbaseio/reactivesearch/issues/1530
                  if ((_c = (_b = response === null || response === void 0 ? void 0 : response.aggregations) === null || _b === void 0 ? void 0 : _b.reactivesearch_nested) === null || _c === void 0 ? void 0 : _c.reactify_nested_outer) {
                    response.aggregations.reactivesearch_nested = replaceDocCountWithParent((_e = (_d = response === null || response === void 0 ? void 0 : response.aggregations) === null || _d === void 0 ? void 0 : _d.reactivesearch_nested) === null || _e === void 0 ? void 0 : _e.reactify_nested_outer);
                  }

                  return _context.abrupt("return", response);

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
      },
      headers: {
        "x-reactify-shop": options.shopifyPermanentDomain,
        "x-reactify-mode": options.mode,
        "x-reactify-client-id": options.clientId,
        "x-reactify-client-version": package_json_1.default.version,
        "x-reactify-ga": (0, hooks_1.getCookie)("_rs_ga")
      }
    };
  }, [options.index, config.endpoint, options.credentials, options.theme, (_a = options.preload) === null || _a === void 0 ? void 0 : _a.state]);
  return reactiveBaseProps;
};

exports.useReactiveBaseProps = useReactiveBaseProps;